/**
 * Check the status of the application against the heartbeat data returned
 * from the API.
 *
 * @param {object} data
 * @param {object} error
 * @returns boolean
 */
export const checkHeartbeatStatus = (data, error) => {
  let appOfflineStatus = false;

  // If error is not null (showing an error) or heartbeatData is undefined, then the app is offline
  if (error !== null || data === 'undefined') appOfflineStatus = true;
  // If data is defined
  else if (typeof data !== 'undefined') {
    // Verify data structure
    if (typeof data.message === 'undefined') appOfflineStatus = true;
    // Check if the message property is set to failure
    else if (data.message === 'failure') appOfflineStatus = true;
  }

  return appOfflineStatus;
};
